import axios from "axios";
import * as types from "./mutation_types";

export const retrieve = ({ commit }) => {
  commit(types.USER_SHOW_TOGGLE_LOADING);
  axios
    .get("/api/user/")
    .then((response) => {
      commit(types.USER_SHOW_TOGGLE_LOADING);
      commit(types.USER_SHOW_SET_RETRIEVED, response.data);
    })
    .catch((e) => {
      commit(types.USER_SHOW_TOGGLE_LOADING);
      commit(types.USER_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.USER_SHOW_RESET);
};
